import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as ajaxActions from "../../../actions/ajaxCounterActions";

import redirector from "../../../util/redirector";
import KalenderGoedkeurenForm from "./KalenderGoedkeurenForm";
import KalenderGoedkeurenPageHelper from "./KalenderGoedkeurenPageHelper";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";

class KalenderGoedkeurenPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: null,
            errors: {},
            shouldScrollToFirstError: false
        };

        this.pageHelper = new KalenderGoedkeurenPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
        window.parent.scrollTo(0, 450);
    };

    handleOnChangeGoedkeuren = (index, event) => this.pageHelper.onChangeGoedkeuren(index, event);
    handleOnChangeRedenVanAfkeuring = (tochtId, event) => this.pageHelper.onChangeRedenVanAfkeuring(tochtId, event);
    handleOnSave = () => this.pageHelper.onSave();

    isReadyToRender = () => {
        return this.state.model;
    };

    render() {
        if (!this.isReadyToRender())
            return null;

        const model = this.state.model;
        const errors = this.state.errors;
        const provincieId = this.props.match.params.provincieId;
        const provincie = provincieId ? this.props.provincies.filter(p => p.value == provincieId)[0].label : "Alle Vlaamse provincies";

        return (
            <KalenderGoedkeurenForm
                model={model}
                onChangeRedenVanAfkeuring={this.handleOnChangeRedenVanAfkeuring}
                onChangeGoedkeuren={this.handleOnChangeGoedkeuren}
                onSave={this.handleOnSave}
                errors={errors}
                validationMessageType={this.state.validationMessageType}
                provincie={provincie}
            />);
    }
}

KalenderGoedkeurenPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        provincies: state.referentie.provinciesInVlaamsGewest
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        loadLayout: bindActionCreators(layoutActions.loadKalenderGoedkeurenPageLayout, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(KalenderGoedkeurenPage);